<template>
  <div class="gallery-box">
    <div style="height: 85px;"></div>
    <div class="layout-container" style="width: 100%">
      <div class="centered-wrapper" v-if="appInfo">
        <section>
          <aside class="contentBox">
            <div class="dingWei">
              <div class="headImgBox">
                <img class="headImg" :src="appInfo.icon" />
              </div>
              <p class="appNameBox">
                <span class="appName">{{ appInfo.title }}</span>
                <span class="guanFang">官方</span>
              </p>
              <p class="dataBox">
                <span class="fen">{{ appInfo.score }}分</span><span class="number"><span class="downloadNum">{{
                    appInfo.downloadNum }}万</span>下载</span><span class="size">{{ appInfo.appSize }}</span>
              </p>
              <div class="downloadBox downloadBox1" style="">
                <button class="download">
                  <span class="liji">下载APP</span>
                </button>
              </div>

              <div class="downloadBox downloadBox3" style="display: none">
                <button class="download">
                  <span class="lijiNo">敬请期待</span>
                </button>
              </div>
            </div>
            <div class="bottomWrap">
              <div class="bottomBox">
                <div class="bannerBox swiper-container-horizontal">
                  <template v-if="appInfo.imgList && appInfo.imgList.length < 6">
                    <div class="swiper-container">
                      <div class="swiper-wrapper">
                        <div class="swiper-slide" style="width: 337px" v-for="(img, index1) in appInfo.imgList"
                          :key="index1">
                          <img id="banner0" :src="img" style="width: 435px" />
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
                <div class="instruct">
                  <pre class="desc">{{ appInfo.introduce }}</pre>
                </div>
                <p class="version">
                  版本：<span class="versionNum">{{ appInfo.version }}</span>
                </p>
                <p class="updataTime">
                  更新时间：<span class="updataDate">{{
                    appInfo.appTime
                    }}</span>
                </p>
                <div class="tips">
                  <img src="../assets/images/product/icon1.png" />
                  <span class="tips-virus">无病毒</span>
                  <span class="tips-virus"></span>
                  <img src="../assets/images/product/icon2.png" />
                  <span class="tips-adver">无广告</span>
                </div>
              </div>
            </div>
          </aside>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { getAppInfoDetails } from "@/api/api";
export default {
  name: "ProductDetailsView",
  data() {
    return {
      appInfo: "",
      swiper: null,
      slidesPerView: 2
    };
  },
  created() {
    this.getProductById(this.$route.query.id);
  },
  updated() {
    this.swiper = new Swiper(".swiper-container", {
      initialSlide: 0, //初始化
      slidesPerView: this.slidesPerView, //页面显示几个
      // centeredSlides: true, // 居中幻灯片
      spaceBetween: 5, //在slide之间设置距离（单位px）
      //可选选项，自动滑动
      autoplay: {
        delay: 1500
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  },
  methods: {
    getProductById(typeDetailsId) {
      getAppInfoDetails(typeDetailsId).then(resp => {
        if (resp) {
          this.appInfo = resp.data.data;
          if (this.appInfo.imgList.length === 1) {
            this.slidesPerView = 1;
          }
        }
      });
    }
  }
};
</script>

<style scoped>
* {
  outline: none;
  box-sizing: border-box;
}

.centered-wrapper {
  width: 1050px;
  margin: 0 auto;
}

.contentBox {
  width: 100%;
  left: 0;
  top: 0;
  z-index: 999;
}

.contentBox .dingWei {
  width: 100%;
  margin-top: 20px;
  background: #edf2f4;
}

.contentBox .headImgBox {
  width: 100%;
  text-align: center;
  padding-top: 1.8rem;
  padding-bottom: 0.3125rem;
}

.contentBox .headImgBox .headImg {
  width: 100px;
}

.contentBox .appNameBox {
  text-align: center;
}

.contentBox .appNameBox .appName {
  color: #3a3a3a;
  font-size: 30px;
  letter-spacing: 2px;
}

.contentBox .appNameBox .guanFang {
  color: #da7272;
  font-size: 0.825rem;
  border: 0.0625rem solid rgba(253, 195, 195, 0.8);
  background-color: rgba(241, 105, 105, 0.1);
  line-height: 0.75rem;
  vertical-align: 0.0625rem;
  padding: 2px;
  margin-left: 20px;
  letter-spacing: 1px;
}

.contentBox .dataBox {
  font-size: 15px;
  text-align: center;
  color: #939393;
  padding-top: 0.1875rem;
  padding-bottom: 1.1875rem;
}

.contentBox .dataBox .number {
  padding: 0 15px;
}

.contentBox .download {
  position: relative;
  border: none;
  outline: none;
  background-color: #00a3ef;
  color: #fff;
  height: 3.225rem;
  line-height: 3.225rem;
  width: 18rem;
  font-size: 1.5375rem;
  letter-spacing: 1px;
}

.contentBox .download1 {
  margin-right: 2.25rem;
}

.contentBox .downloadBox {
  text-align: center;
  padding-bottom: 2.3125rem;
}

.contentBox .download .liji {
  position: relative;
  left: -0.625rem;
}

.contentBox .download .lijiNo {
  position: relative;
  left: -0.625rem;
}

.contentBox .download .liji:after {
  position: absolute;
  content: "";
  right: -1.55rem;
  top: 0.8rem;
  width: 0.75rem;
  height: 0.8125rem;
  font-size: 1.3375rem;
  background: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHByZXNlcnZlQXNwZWN0UmF0aW89InhNaWRZTWlkIiB3aWR0aD0iMjQiIGhlaWdodD0iMjUuOTM4IiB2aWV3Qm94PSIwIDAgMjQgMjUuOTM4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjtmaWxsLXJ1bGU6ZXZlbm9kZH08L3N0eWxlPjwvZGVmcz48cGF0aCBkPSJNMTMuNjYzIDE5Ljc2OGwuMTU1LjE1Ni0xLjY2NyAxLjY4LS4xNTUtLjE1Ni0uMTU1LjE1Ni0xLjY2Ny0xLjY4LjE1NS0uMTU2LTkuNDktOS41NjMgMS42NjgtMS42NzkgOC40MDIgOC40NjZWLS4wMDZoMi4xNzR2MTYuOTk4bDguNDAyLTguNDY2IDEuNjY3IDEuNjc5LTkuNDg5IDkuNTYzem04Ljc1OCA2LjE3NkgxLjU3MXYtMi4xNzVoMjAuODV2Mi4xNzV6IiBjbGFzcz0iY2xzLTEiLz48L3N2Zz4=) no-repeat 0 0;
  background-size: 100% auto;
}

.contentBox .bottomWrap {
  position: relative;
  background-image: linear-gradient(to bottom, #d6dbdd, #edf2f4 0.25rem);
  padding: 0.5rem 0;
}

.contentBox .bottomWrap .bottomBox {
  padding: 1.5rem 0.75rem 0.75rem 0.75rem;
  margin: 0 0.75rem;
  box-shadow: 0 0 0.1875rem 0 rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.bannerBox {
  display: flex;
  text-align: center;
  padding-bottom: 0.8125rem;
  border-bottom: 0.125rem solid #909090;
  margin-bottom: 0.375rem;
}

.bottomBox .instruct .desc {
  line-height: 1.5;
  font-size: 1.4rem;
  color: #343434;
  letter-spacing: 1px;
  text-align: left;
}

.bottomBox .instruct .ellipsis {
  height: 2.5rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.bottomBox .version,
.bottomBox .updataTime,
.bottomBox .tips {
  color: #939393;
  font-size: 1.3rem;
  letter-spacing: 1px;
}

.bottomBox .version {
  padding-top: 1.1875rem;
}

.bottomBox .tips {
  padding-top: 0.6875rem;
}

.bottomBox .tips img {
  vertical-align: -0.1875rem;
}

.bottomBox .tips span {
  padding-left: 0.5rem;
}

.bottomBox .tips .tips-virus {
  padding-right: 1.375rem;
}
</style>
